import {setStorageItem, useDeimosStorageWithCompanyId} from '@product-web/api/deimos/storage'
import {useUser} from '@product-web/shell/user'

export type PricingPlan = 'free' | 'pro' | 'starter' | 'essential'

const isValidPricingPlan = (plan: string | undefined): plan is PricingPlan => {
    return Boolean(
        plan && ['free', 'pro', 'starter', 'essential', 'advanced', 'team'].includes(plan),
    )
}

export const savePricingPlan = ({plan, companyId}: {plan?: string | null; companyId: string}) => {
    if (plan && isValidPricingPlan(plan)) {
        setStorageItem({
            key: 'pricing_plan',
            value: plan,
            companyId,
            membership: 'owner',
            sendNotification: false,
        })
    }
}

export function usePricingPlan(): {pricingPlan: PricingPlan} {
    const user = useUser()
    const {
        result: {data: pricingPlanData},
    } = useDeimosStorageWithCompanyId('pricing_plan', user?.companyId)

    return {
        pricingPlan: (pricingPlanData?.value ?? 'starter') as PricingPlan,
    }
}
